<!--
Created on 2021-04-10
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-10
-->
<template>
  <div id="menu-success" class="menu menu-box-modal rounded-m" 
      data-menu-height="230" 
      data-menu-width="310">
    <h1 class="text-center mt-3 pt-1"><i class="fa fa-3x fa-check-circle color-green-dark shadow-xl rounded-circle"></i></h1>
    <h1 class="text-center mt-3 font-700">{{ title }}</h1>
    <p class="boxed-text-l">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'SuccessModal',
  props: {
    title: {
      type: String,
      default: 'Úspešne uložené'
    },
    message: {
      type: String,
      default: 'Úspešne uložené.'
    }
  },
  setup() {
    
  },
}
</script>

<style>

</style>